/* @generated from adl */
import { declResolver, ScopedDecl } from "./runtime/adl";
import { _AST_MAP as common } from "./common";
import { _AST_MAP as common_adminui_api } from "./common/adminui/api";
import { _AST_MAP as common_adminui_db } from "./common/adminui/db";
import { _AST_MAP as common_config_aws } from "./common/config/aws";
import { _AST_MAP as common_config_log } from "./common/config/log";
import { _AST_MAP as common_db } from "./common/db";
import { _AST_MAP as common_http } from "./common/http";
import { _AST_MAP as common_strings } from "./common/strings";
import { _AST_MAP as common_tabular } from "./common/tabular";
import { _AST_MAP as common_ui } from "./common/ui";
import { _AST_MAP as hotel_api } from "./hotel/api";
import { _AST_MAP as hotel_booking } from "./hotel/booking";
import { _AST_MAP as hotel_common } from "./hotel/common";
import { _AST_MAP as hotel_db } from "./hotel/db";
import { _AST_MAP as hotel_uiconfig } from "./hotel/uiconfig";
import { _AST_MAP as ids_common } from "./ids/common";
import { _AST_MAP as ids_db } from "./ids/db";
import { _AST_MAP as ids_externalapi } from "./ids/externalapi";
import { _AST_MAP as ids_hotel } from "./ids/hotel";
import { _AST_MAP as sys_adlast } from "./sys/adlast";
import { _AST_MAP as sys_annotations } from "./sys/annotations";
import { _AST_MAP as sys_types } from "./sys/types";

export const ADL: { [key: string]: ScopedDecl } = {
  ...common,
  ...common_adminui_api,
  ...common_adminui_db,
  ...common_config_aws,
  ...common_config_log,
  ...common_db,
  ...common_http,
  ...common_strings,
  ...common_tabular,
  ...common_ui,
  ...hotel_api,
  ...hotel_booking,
  ...hotel_common,
  ...hotel_db,
  ...hotel_uiconfig,
  ...ids_common,
  ...ids_db,
  ...ids_externalapi,
  ...ids_hotel,
  ...sys_adlast,
  ...sys_annotations,
  ...sys_types,
};

export const RESOLVER = declResolver(ADL);
